import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()
export class NoLoginGuard implements CanActivate {

  constructor(private router:Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    //Se agregan las condiciones para despues del logueo
    //Si localStorage es igual a null no hace nada,
    //de lo contrario permite redireccionar al dashboard hasta que se desloguee
    if (localStorage.getItem('usuarioid') === null)
    {
      return true;
    }
    else
    {
      this.router.navigate(['/main']);
      return false;
    }
  }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/login/no-login.guard.ts